import TemplateView from "../../../../TemplateView";
import Breadcrumb from "./Breadcrumb";
import messageResource from '../../../../messageResource';

export default class BreadcrumbsPanel extends TemplateView {
    constructor({
        onCustomerClose = () => {},
        onProjectClose = () => {}
    }) {
        super()

        this.callbacks = {
            onCustomerClose,
            onProjectClose
        }

        this.state = {
            customerName: '',
            projectName: ''
        }

        this.onStateDeeplyChanged(state => {
            this.customerBreadcrumb.setState({
                text: state.customerName
            })
            this.projectBreadcrumb.setState({
                text: state.projectName
            })

            this.$customer.toggle(!!state.customerName)
            this.$project.toggle(!!state.projectName)
            this.$separator.toggle(!!state.projectName);
        })
    }

    templateHtml() {
        return "<div class='breadcrumbsPanel'>" +
               "  <div class='breadcrumbContainer customer'></div>" +
               "  <div class='projectBreadcrumbContainer'>" +
               "    <div class='separator'></div>" +
               "    <div class='breadcrumbContainer project'></div>" +
               "</div>" +
               "</div>"
    }

    afterRender() {
        this.$customer = this.find('.customer')
        this.customerBreadcrumb = new Breadcrumb({
            onClose: () => this.callbacks.onCustomerClose()
        }).init(this.$customer)
        this.customerBreadcrumb.setState({
            caption: messageResource.getMessage('common.Customer')
        })

        this.$separator = this.find('.separator')
        this.$project = this.find('.project');
        this.projectBreadcrumb = new Breadcrumb({
            onClose: () => this.callbacks.onProjectClose()
        }).init(this.$project)
        this.projectBreadcrumb.setState({
            caption: messageResource.getMessage('common.Project')
        })

        this.renderInitialState()
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/components/hierarchyAssignmentsEditor/BreadcrumbsPanel.js